import React from 'react';

import Reparafone from '../../../../images/trocafone-logo.png';

const Logo = () => (
  <div className="logo">
    <a className="logo-link" href="/novaordem">
      <img className='mylogo' src={Reparafone} alt="Reparofone" />
    </a>
  </div>
);

export default Logo;
